import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: '80vh'
    },
    providerIcon: {
        height: 25
    },
    itemsInRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 5
    }
});

export {useStyles};